<div class="container purchase-app tw-px-[15px]" ui-view></div>
